import environments from './environments';
import assetsConfig from '../../../config/app.json';

const devAssets = assetsConfig.appConfig?.localhost.assets || {};
const prodAssets = assetsConfig.globalConfig.assets || {};

export default {
    [environments.PRODUCTION]: prodAssets,
    [environments.DEVELOPMENT]: devAssets,
};
